/**
 * TTS服务商类型
 */

export const PROVIDER_TYPE={
    ALIYUN:"aliyun"       // 阿里云语音
};